import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import store from '@/store/store'

import Entry from '@/views/Entry.vue'
import ListEntries from '@/views/entry/ListEntries.vue'
import ShowEntry from '@/views/entry/ShowEntry.vue'
// import UpdateEntry from '@/views/entry/UpdateEntry.vue'

import Login from '@/views/Login.vue'
import SignIn from '@/views/login/SignIn.vue'
import Register from '@/views/login/Register.vue'
import Reminder from '@/views/login/Reminder.vue'
import Reset from '@/views/login/Reset.vue'

import Admin from '@/views/Admin.vue'
import Dashboard from '@/views/admin/Dashboard.vue'
import Entries from '@/views/admin/Entries.vue'
import Registrations from '@/views/admin/Registrations.vue'
import User from '@/views/admin/User.vue'
import AdminListEntries from '@/views/admin/entry/AdminListEntries.vue'
import AdminShowEntry from '@/views/admin/entry/AdminShowEntry.vue'
import AdminUpdateEntry from '@/views/admin/entry/AdminUpdateEntry.vue'

import Review from '@/views/review/Review.vue'
import CompletedEntries from '@/views/review/CompletedEntries.vue'
import CompletedEntry from '@/views/review/CompletedEntry.vue'

import Judging from '@/views/judging/Judging.vue'
import JudgingEntries from '@/views/judging/JudgingEntries.vue'
import JudgingEntry from '@/views/judging/JudgingEntry.vue'
import JudgingSummary from '@/views/judging/JudgingSummary.vue'

import Shortlist from '@/views/shortlist/Shortlist.vue'

import firebaseSrv from '@/services/firebaseSrv.js'
// import store from '@/store/store.js'

Vue.use(Router)

// console.log('In router: ' + firebaseSrv.auth.currentUser)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      // name: 'entry',
      component: Entry,
      props: true,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/',
          name: 'list-entries',
          component: ListEntries,
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: '/entries/:eid',
          name: 'show-entry',
          component: ShowEntry,
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: '/update/:eid',
          name: 'update-entry',
          component: ShowEntry,
          props: true,
          beforeEnter: requireAuth
        }
      ]
    },
    {
      path: '/login',
      // name: 'login',
      component: Login,
      props: true,
      children: [
        {
          path: '/',
          name: 'sign-in',
          component: SignIn
        },
        {
          path: '/register',
          name: 'register',
          component: Register
        },
        {
          path: '/reminder',
          name: 'reminder',
          component: Reminder
        },
        {
          path: '/reset',
          name: 'reset',
          component: Reset
        }
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      beforeEnter: requireAdmin,
      props: true,
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: '/admin/entries',
          name: 'entries',
          component: Entries
        },

        {
          path: '/admin/registrations',
          name: 'registrations',
          component: Registrations
        },
        {
          path: '/admin/user',
          name: 'user',
          props: true,
          component: User,
          children: [
            {
              path: '/admin/user/:uid',
              name: 'admin-list-entries',
              component: AdminListEntries,
              props: true
            },
            {
              path: '/admin/user/:uid/:eid/show',
              name: 'admin-show-entry',
              component: AdminShowEntry,
              props: true
            },
            {
              path: '/admin/user/:uid/:eid/edit',
              name: 'admin-update-entry',
              component: AdminUpdateEntry,
              props: true
            }
          ]
        }
      ]
    },
    {
      path: '/review',
      name: 'admin-review',
      component: Review,
      beforeEnter: pullCompletedEntries,
      props: true,
      children: [
        {
          path: '/review/completed-entries',
          name: 'completed-entries',
          component: CompletedEntries,
          props: true
        },
        {
          path: '/review/completed-entries/:ceid/',
          name: 'completed-entry',
          component: CompletedEntry,
          props: true
        }
      ]
    },
    {
      path: '/scores',
      name: 'scores',
      beforeEnter: pullJudgesScores,
      component: Shortlist
    },
    { path: '/finalists', name: 'finalists' },
    {
      path: '/judging',
      name: 'judging',
      component: Judging,
      beforeEnter: pullEntriesForReview,
      props: true,
      children: [
        {
          path: '/judging/entries',
          name: 'judging-entries',
          component: JudgingEntries,
          props: true
        },
        {
          path: '/judging/entry/:ceid/',
          name: 'judging-entry',
          component: JudgingEntry,
          props: true
        },
        {
          path: '/judging/scores',
          name: 'judging-scores',
          component: JudgingSummary,
          props: true
        }
      ]
    }
  ]
})

function pullJudgesScores(to, from, next) {
  firebaseSrv.auth.onAuthStateChanged(function(user) {
    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      store.state.currentUser = user.uid
      firebaseSrv.auth.currentUser.getIdTokenResult().then(token => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (token.claims.admin) {
          store.dispatch('shortlist/getAllEntries').then(() => next())
        } else {
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      })
    }
  })
}

function pullEntriesForReview(to, from, next) {
  firebaseSrv.auth.onAuthStateChanged(function(user) {
    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      store.state.currentUser = user.uid
      firebaseSrv.auth.currentUser.getIdTokenResult().then(token => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (token.claims.admin) {
          // console.log('am admim')
          store.state.judging.admin = true
        }
        if (token.claims.judge) {
          store.dispatch('judging/getEntries').then(() => next())
        } else {
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      })
    }
  })
}

function pullCompletedEntries(to, from, next) {
  firebaseSrv.auth.onAuthStateChanged(function(user) {
    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      store.state.currentUser = user.uid
      firebaseSrv.auth.currentUser.getIdTokenResult().then(token => {
        if (token.claims.admin) {
          store.dispatch('review/getEntries').then(() => next())
        } else {
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      })
    }
  })
}

function requireAuth(to, from, next) {
  firebaseSrv.auth.onAuthStateChanged(function(user) {
    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      firebaseSrv.auth.currentUser.getIdTokenResult().then(token => {
        if (token.claims.judge) {
          next({
            path: '/judging/entries',
            query: { redirect: to.fullPath }
          })
        } else {
          next()
        }
      })
    }
  })
}

function requireAdmin(to, from, next) {
  firebaseSrv.auth.onAuthStateChanged(function(user) {
    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      firebaseSrv.auth.currentUser.getIdTokenResult().then(token => {
        if (token.claims.admin) {
          store.state.currentUser = user.uid
          const getUsers = store.dispatch('admin/getUsers')
          const getEntrants = store.dispatch('admin/getEntrants')
          Promise.all([getUsers, getEntrants]).then(() => next())
        } else {
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      })
    }
  })
}

router.beforeEach((routeTo, routeFrom, next) => {
  // Start the route progress bar.
  NProgress.start()
  next()
})
router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
